import React, { useState } from 'react';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input';
import { FaPlus, FaTrash } from 'react-icons/fa';

const formatarMoeda = v =>
  Number(v || 0).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const inputMoeda = (valor, aoMudar, disabled) => (
  <CurrencyInput
    value={valor}
    decimalSeparator=","
    thousandSeparator="."
    prefix="R$ "
    className="form-control form-control-sm"
    disabled={disabled}
    onChangeEvent={(event, maskedValue, floatValue) => aoMudar(floatValue)}
  />
);

/**
 * GradeFaixas — gestão das faixas progressivas em estado local (paridade #Tsergio do ERP).
 * Entrada de nova faixa (Inicial/Final/%-Valor) + botão Incluir; grade com botão Excluir por linha.
 * As faixas são enviadas no payload da simulação (sem persistência no backend).
 * `rotuloValor` muda conforme o modo (% Comissão vs Valor Comissão).
 */
const GradeFaixas = ({ faixas = [], setFaixas, rotuloValor, disabled = false }) => {
  const [novaFaixa, setNovaFaixa] = useState({ inicial: 0, final: 0, valor: 0 });

  const incluir = () => {
    if (disabled) return;
    setFaixas([...faixas, { ...novaFaixa }]);
    setNovaFaixa({ inicial: 0, final: 0, valor: 0 });
  };

  const excluir = index => {
    if (disabled) return;
    setFaixas(faixas.filter((f, i) => i !== index));
  };

  return (
    <div>
      <Row className="align-items-end">
        <Col xs="6" md="3">
          <Form.Group>
            <Form.Label>Vl. Inicial</Form.Label>
            {inputMoeda(
              novaFaixa.inicial,
              v => setNovaFaixa({ ...novaFaixa, inicial: v }),
              disabled
            )}
          </Form.Group>
        </Col>
        <Col xs="6" md="3">
          <Form.Group>
            <Form.Label>Vl. Final</Form.Label>
            {inputMoeda(
              novaFaixa.final,
              v => setNovaFaixa({ ...novaFaixa, final: v }),
              disabled
            )}
          </Form.Group>
        </Col>
        <Col xs="6" md="3">
          <Form.Group>
            <Form.Label>{rotuloValor}</Form.Label>
            {inputMoeda(
              novaFaixa.valor,
              v => setNovaFaixa({ ...novaFaixa, valor: v }),
              disabled
            )}
          </Form.Group>
        </Col>
        <Col xs="6" md="3">
          <Button
            variant="outline-primary"
            onClick={incluir}
            disabled={disabled}
            className="mb-2"
          >
            <FaPlus /> <span className="ms-1">Incluir faixa</span>
          </Button>
        </Col>
      </Row>

      <Table size="sm" bordered hover className="mt-2">
        <thead>
          <tr>
            <th className="text-end">Vl. Inicial</th>
            <th className="text-end">Vl. Final</th>
            <th className="text-end">{rotuloValor}</th>
            <th className="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          {faixas.length === 0 ? (
            <tr>
              <td colSpan={4} className="text-center text-muted">
                Nenhuma faixa cadastrada
              </td>
            </tr>
          ) : (
            faixas.map((f, index) => (
              <tr key={index}>
                <td className="text-end">{formatarMoeda(f.inicial)}</td>
                <td className="text-end">{formatarMoeda(f.final)}</td>
                <td className="text-end">{formatarMoeda(f.valor)}</td>
                <td className="text-center">
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => excluir(index)}
                    disabled={disabled}
                    title="Excluir faixa"
                  >
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default GradeFaixas;
